import { SUPER_ADMIN_ID, SYSTEM_USER_ID } from '@shared/constants/user';
import isEmpty from 'lodash/isEmpty';

export const getUserDisplayName = ({
	displayName = '',
	firstName = '',
	lastName = '',
	id = '',
	email = '',
}: {
	firstName?: string | null;
	lastName?: string | null;
	displayName?: string | null;
	id?: string;
	email?: string;
} = {}): string => {
	switch (id) {
		case SYSTEM_USER_ID:
			return 'System';
		case SUPER_ADMIN_ID:
			return 'Super Admin';
		default:
			break;
	}

	const fullName = [firstName, lastName].join(' ');

	if (!isEmpty(displayName)) return displayName!;

	if (!isEmpty(fullName.replace(/ /g, ''))) return fullName;

	if (!isEmpty(email)) {
		return email;
	}

	if (!isEmpty(id)) {
		return `-`;
	}

	return '';
};

export const getUserAvatarName = ({
	displayName = '',
	firstName = '',
	lastName = '',
	iconUrl = '',
}: {
	displayName?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	iconUrl?: string | null;
}): string => {
	const fullName = [firstName, lastName].join(' ');

	if (!isEmpty(iconUrl)) return iconUrl ?? '';

	if (!isEmpty(displayName)) return displayName ?? '';

	if (!isEmpty(fullName.replace(/ /g, ''))) return fullName;

	return '';
};
